<template>
  <div id="app" :class="{ '': !isDarkMode, 'bg-dark': isDarkMode }" :data-bs-theme="isDarkMode ? 'dark' : 'light'">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  metaInfo: {
    title: 'App',
    titleTemplate: '%s | Spencer',
    meta: []
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    layout() {
      return this.$route.meta.layout || 'simple-layout';
    }
  }
};
</script>

<style lang="scss">
#app {
  // prettier-ignore
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #19243b;
  min-height: 100vh;
}

@import '../src/assets/css/custom.css';
@import '../src/assets/css/login.css';
@import '../src/assets/css/admin-theme.css';
@import '../src/assets/css/action-buttons.css';
@import '../src/assets/css/admin-table-global.css';
@import '../src/assets/css/admin-form-global.css';
@import '../src/assets/css/admin-upload-modal.css';
@import '../src/assets/css/admin-plan-form.css';
</style>
